/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function SelectorCombo(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'SelectorCombo',
      'aria-hidden': true,
      focusable: false,
      width:  10 * scale,
      height: 17 * scale,
      viewBox: '0 0 10 17',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fill":"currentColor","d":"M9 11H6V8H4v3H1v2h3v3h2v-3h3z"}),createElement('path', {"fill":"currentColor","d":"M4 1h2v4H4z","opacity":".3"}))
}
